import
  React
from 'react';

import {
  HContainerV,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from 'constants';

export const SocialBundleMarketingBanner = props => {

  return (

    <HContainerV
      background={CustomColors.GradientBlue}
      color={CustomColors.White}
      justifyContent={'space-around'}
      width={'344px'}>

      <VContainer
        background={`url(${Icons.Banner})`}
        width={'inherit'}
        height={'300px'}
        >

      <VContainer
        margin={'150px 0px 0px 16px'}
        width={'200px'}
        height={'100px'}
        >

          <Text
            fontSize={'32px'}
            fontWeight={'700'}
            lineHeight={'38.4px'}
            font={'Inter'}>
              {'FREE'}
          </Text>

          <Text
            fontSize={'48px'}
            fontWeight={'700'}
            lineHeight={'38.4px'}
            font={'Inter'}>
            {props.socialBundleType}
          </Text>

          <Text
            fontSize={'32px'}
            fontWeight={'700'}
            lineHeight={'38.4px'}
            font={'Inter'}>
              {'bundle'}
          </Text>
      </VContainer>

      </VContainer>

    </HContainerV>

  );
};